import Swal from 'sweetalert2';


/**
 * The logic below provides a dialog for delete actions
 */
let deleteForms = document.querySelectorAll('.delete-form');

if (deleteForms) {
    for (let i = 0; i < deleteForms.length; i++){
        deleteForms[i].addEventListener('submit', e => {
            e.preventDefault();
            let target = e.target;
            let title = target.dataset?.title ?? 'Are you sure?';
            let message = target.dataset?.message ?? "You may not be able to revert this!";

            Swal.fire({
                title,
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Continue!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        target.submit();
                }
            });
        })
    }
}
